import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import { AuthLayout, PublicLayout, MinimalLayout } from './components/layout/Layouts';
import Home from './pages/Home';
import SignupPage from './pages/SignupPage'
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard/Index';
import Hr from './pages/Dashboard/HR/Index';
import Attendance from './pages/Dashboard/HR/Attendance';
import StaffOnboard from './pages/Dashboard/HR/StaffOnboard';
import AllStaffPage from './pages/Dashboard/HR/AllStaff';
import Payroll from './pages/Dashboard/Payroll/Index';
import NotFound from './pages/NotFound';
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProtectedRoute from './components/ProtectedRoute';

function LayoutWrapper({ children }) {
    const location = useLocation();
    
    // Login page uses minimal layout
    if (location.pathname === "/login" || location.pathname === "/signup") {
        return <MinimalLayout>{children}</MinimalLayout>;
    }

    // Authenticated routes use AuthLayout
    const authenticatedRoutes = ["/dashboard", "/hr", "/attendance", "/profile", "/settings", "/staff-onboard", "/all-staff", "/payroll"];
    if (authenticatedRoutes.some(route => location.pathname.startsWith(route))) {
        return <AuthLayout>{children}</AuthLayout>;
    }

    // All other routes use PublicLayout
    return <PublicLayout>{children}</PublicLayout>;
};

function App() {
    return (
      <AuthProvider>
        <Router>
            <LayoutWrapper>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/dashboard" element={ 
                        <ProtectedRoute> 
                            <Dashboard />
                        </ProtectedRoute> } 
                    />
                    <Route path="/hr" element={
                        <ProtectedRoute>
                            <Hr />
                        </ProtectedRoute>} 
                    />
                    <Route path="/attendance" element={
                        <ProtectedRoute>
                            <Attendance />
                        </ProtectedRoute>} 
                    />
                    <Route path="/staff-onboard" element={
                        <ProtectedRoute>
                            <StaffOnboard />
                        </ProtectedRoute>} 
                    />
                    <Route path="/payroll" element={
                        <ProtectedRoute>
                            <Payroll />
                        </ProtectedRoute>} 
                    />
                    <Route path="/all-staff" element={
                        <ProtectedRoute>
                            <AllStaffPage />
                        </ProtectedRoute>} 
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <ToastContainer />
            </LayoutWrapper>
        </Router>
      </AuthProvider>
    );
}

export default App;